import http from './axios'

export default {
  adminRegister: (email, password, factory_id, country_code, phone) =>
    http.post('user/admin-register/', {
      email: email,
      password: password,
      factory_name: factory_id,
      country_code: country_code,
      phone: phone,
    }),
  operatorRegister: (email, password, factory_id, country_code, phone) =>
    http.post('user/operator-register/', {
      email: email,
      password: password,
      factory: factory_id,
      country_code: country_code,
      phone: phone,
    }),
  suppliers: () => http.get('factory/supplier/user-supplier/'),
  readSupplier: (id) => http.get(`factory/supplier/user-supplier/${id}/`),
  supplierRegister: (email, password, country_code, phone) =>
    http.post('user/supplier-register/', {
      email: email,
      password: password,
      country_code: country_code,
      phone: phone,
    }),
  operatorList: (page = 1, isVerify = null, count = null) => http.get(`user/operators/?page=${page}${isVerify !== null ? `&is_verify_operator=${isVerify}` : ''}${count !== null ? `&count=${count}` : ''}`),
  readOperator: (id) => http.get(`user/operators/${id}/`),
  addOperator: (email) =>
    http.post('user/send-invite/', {
      emails: email,
    }),
  editOperator: (id, first_name, last_name, operation, station, level) =>
    http.patch(`user/operators/${id}/`, {
      first_name: first_name,
      last_name: last_name,
      operation: operation,
      station: station,
      level: level,
    }),
  editOperatorShifts: (id, shifts) =>
    http.patch(`user/operators/${id}/`, {
      shift: shifts,
    }),
  deleteOperator: (id) => http.delete(`user/operators/${id}/`),
  groups: (page = 1) => http.get(`factory/group/?page=${page}`),
  addGroup: (name, operators, description) =>
    http.post('factory/group/', {
      name: name,
      user_group: operators,
      description: description,
    }),
  editGroup: (id, name, operators, description) =>
    http.put(`factory/group/${id}/`, {
      name: name,
      user_group: operators,
      description: description,
    }),
  deleteGroup: (id) => http.delete(`factory/group/${id}/`),
  levels: (page = 1) => http.get(`user/user-level/?page=${page}`),
  readLevel: (id) => http.get(`user/user-level/${id}/`),
  addLevel: (name, points, ratio, badge) => {
    let fd = new FormData()
    fd.append('name', name)
    fd.append('points', points)
    fd.append('ratio', ratio)
    fd.append('badge', badge)
    return http.post('user/user-level/', fd)
  },
  editLevel: (id, name, points, ratio, badge) => {
    let fd = new FormData()
    fd.append('name', name)
    fd.append('points', points)
    fd.append('ratio', ratio)
    if (badge) fd.append('badge', badge)
    return http.patch(`user/user-level/${id}/`, fd)
  },
  deleteLevel: (id) => http.delete(`user/user-level/${id}/`),
  verifyOperator: (id, verify) =>
    http.patch(`user/operators/${id}/`, {
      is_verify_operator: verify,
    }),
  userRegister: (email, password, uuid) =>
    http.post('user/register-invite/', {
      email: email,
      password: password,
      uuid: uuid,
    }),
  users: (page = 1) => http.get(`user/users-info/?page=${page}`),
  token: (email, password) =>
    http.post('token/', {
      email: email,
      password: password,
    }),
  google_login: (credential) =>
    http.post('google/login/', {
      auth_token: credential,
    }),
  google_register: (credential, country_code, phone, role, factory) =>
    http.post('google/register/', {
      auth_token: credential,
      phone: phone,
      country_code: country_code,
      role: role,
      factory: factory,
    }),
  forgot: (email) =>
    http.post('user/password-reset/', {
      email: email,
    }),
  reset: (password, token) =>
    http.post('user/password-reset/confirm/', {
      password: password,
      token: token,
    }),
  stationList: (id = null, page = 1, active = true, operation = null, search = null, count = null) =>
    http.get(`factory/station/?page=${page}${id ? `&line=${id}` : ''}${operation ? `&operation=${operation}` : ''}&is_active=${active}${search !== null ? `&search=${search}` : ''}${count !== null ? `&count=${count}` : ''}`),
  readStation: (id) => http.get(`factory/station/${id}/`),
  addStation: (name, line, imageFile, location_id, processing_time, local_url = '') => {
    let fd = new FormData()
    fd.append('name', name)
    fd.append('line', line)
    fd.append('station_image', imageFile)
    fd.append('is_active', true)
    fd.append('location', location_id)
    fd.append('last_efficiency', 0)
    fd.append('minimum_efficiency', 0)
    fd.append('downtime_percent', 0)
    fd.append('loss_quantity', 0)
    fd.append('quality', 0)
    fd.append('downtime', 0)
    fd.append('processing_time', processing_time)
    if (local_url !== '') fd.append('local_url', local_url)
    return http.post('factory/station/', fd)
  },
  addVirtualStation: (name, line, start, stop) =>
    http.post('factory/station/', {
      name: name,
      line: line,
      is_active: true,
      is_virtual: true,
      is_start: start,
      is_stop: stop,
      location: '',
      downtime_percent: 0,
      loss_quantity: 0,
      quality: 0,
      downtime: 0,
    }),
  editStation: (id, name, imageFile, location_id, processing_time, local_url = null) => {
    let fd = new FormData()
    fd.append('name', name)
    fd.append('processing_time', processing_time)
    if (imageFile) fd.append('station_image', imageFile)
    if (location_id) fd.append('location', location_id)
    if (local_url !== null) fd.append('local_url', local_url)
    return http.patch(`factory/station/${id}/`, fd)
  },
  lineList: (page = 1, search = null) => http.get(`factory/line/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  readLine: (id) => http.get(`factory/line/${id}/`),
  addLine: (name, image) => {
    let fd = new FormData()
    fd.append('name', name)
    fd.append('is_active', true)
    if (image) fd.append('image', image)
    return http.post('factory/line/', fd)
  },
  editLine: (id, name, image) => {
    let fd = new FormData()
    fd.append('name', name)
    if (image) fd.append('image', image)
    return http.patch(`factory/line/${id}/`, fd)
  },
  deleteLine: (id) =>
    http.patch(`factory/line/${id}/`, {
      is_active: false,
    }),
  deleteStation: (id) =>
    http.patch(`factory/station/${id}/`, {
      is_active: false,
    }),
  restoreStation: (id) =>
    http.patch(`factory/station/${id}/`, {
      is_active: true,
    }),
  shiftList: () => http.get('factory/shift/'),
  addShift: (shift_name, start_time, stop_time, work_days) =>
    http.post('factory/shift/', {
      shift_name: shift_name,
      start_time: start_time,
      stop_time: stop_time,
      work_days: work_days,
    }),
  editShift: (id, shift_name, start_time, stop_time, work_days) =>
    http.patch(`factory/shift/${id}/`, {
      shift_name: shift_name,
      start_time: start_time,
      stop_time: stop_time,
      work_days: work_days,
    }),
  deleteShift: (id) => http.delete(`factory/shift/${id}/`),
  timelines: () => http.get('factory/group-schedule/'),
  setTimeline: (date, group, shift) =>
    http.post('factory/group-schedule/', {
      date: date,
      group: group,
      shift: shift,
    }),
  editTimeline: (id, group) =>
    http.patch(`factory/group-schedule/${id}/`, {
      group: group,
    }),
  deleteTimeline: (id) => http.delete(`factory/group-schedule/${id}/`),
  watcherList: (page = 1, search = null) =>
    http.get(`factory/watcher/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  addWatcher: (name, register_id, station, computation, multiplication_factor, priority, timeout) =>
    http.post('factory/watcher/', {
      name: name,
      register_id: register_id,
      station: station,
      computation: computation,
      location: null,
      multiplication_factor: multiplication_factor,
      priority: priority,
      timeout: timeout,
    }),
  editWatcher: (id, name, station, computation, multiplication_factor, priority, timeout) =>
    http.patch(`factory/watcher/${id}/`, {
      name: name,
      station: station,
      computation: computation,
      location: null,
      multiplication_factor: multiplication_factor,
      priority: priority,
      timeout: timeout,
    }),
  reportWatcher: (register_id, lot_no, quantity, extra_info, product_id, product_info, time) =>
    http.post('factory/image-update-watcher-data/', {
      register_id: register_id,
      lot_info: lot_no,
      extra_info: extra_info,
      product_id: product_id,
      product_info: product_info,
      timestamp: time,
      ...(() => {
        quantity = parseInt(quantity)
        if (quantity) return { quantity }
      })(),
    }),
  reportWatcherStatus: (register_id, quantity, lot_no) => {
    if (lot_no) {
      return http.post('factory/image-update-watcher-data/', {
        register_id: register_id,
        quantity: quantity,
        lot_info: lot_no,
      })
    } else {
      return http.post('factory/image-update-watcher-data/', {
        register_id: register_id,
        quantity: quantity,
      })
    }
  },
  reportWatcherStatusExtra: (register_id, extra_info) => {
    return http.post('factory/image-update-watcher-data/', {
      register_id: register_id,
      extra_info: extra_info,
      quantity: 0,
    })
  },
  reportWatcherMark: (register_id, lot_no) => {
    if (lot_no) {
      return http.post('factory/image-update-watcher-data/', {
        register_id: register_id,
        defect_quantity: 1,
        lot_info: lot_no,
      })
    } else {
      return http.post('factory/image-update-watcher-data/', {
        register_id: register_id,
        defect_quantity: 1,
      })
    }
  },
  reportWatcherProduct: (register_id, product_id) =>
    http.post('factory/image-update-watcher-data/', {
      register_id: register_id,
      product_id: product_id,
      quantity: 1,
    }),
  reportWatcherQuality: (register_id, lot_no, extra_info, product_info, quantity) =>
    http.post('factory/image-update-watcher-data/', {
      register_id,
      lot_info: lot_no,
      product_info,
      ...(() => {
        quantity = parseInt(quantity)
        if (quantity) return { quantity }
      })(),
      extra_info: {
        notes: extra_info,
      },
    }),
  reportWatcherCapture: (register_id, extra_info) =>
    http.post('factory/image-update-watcher-data/', {
      register_id: register_id,
      lot_info: 0,
      extra_info: extra_info,
    }),
  reportWatcherDowntime: (register_id) =>
    http.post('factory/update-watcher/', {
      register_id: register_id,
      quantity: 0,
      defect_quantity: 0,
    }),
  reportWatcherImage: (register_id, elastic_id, image) => {
    let fd = new FormData()
    fd.append('register_id', register_id)
    fd.append('elastic_id', elastic_id)
    if (image) fd.append('image', image, 'image.png')
    return http.post('factory/image-update-watcher/', fd)
  },
  reportWatcherRework: (station_id, quantity, image) => {
    let fd = new FormData()
    fd.append('station', station_id)
    fd.append('quantity', quantity)
    if (image) fd.append('image', image)
    return http.post('factory/report-rework/', fd)
  },
  reportIssueList: (page = 1, search = null) =>
    http.get(`factory/supplier/issue/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  reportIssue: (station, description, images, is_access, for_time, send_directly, suppliers, post_supplier) => {
    let fd = new FormData()
    fd.append('station', station)
    fd.append('description', description)
    fd.append('is_access', is_access)
    fd.append('for_time', for_time)
    fd.append('is_send_directly', send_directly)
    fd.append('is_post_supplier', post_supplier)

    let inss = suppliers.length
    for (let i = 0; i < inss; i++) {
      fd.append('users_id', suppliers[i])
    }

    let ins = images.length
    for (let i = 0; i < ins; i++) {
      fd.append('uploaded_images', images[i])
    }

    return http.post('factory/supplier/issue/', fd)
  },
  showIssues: () => http.get('factory/supplier/show-issues/'),
  readIssues: (id) => http.get(`factory/supplier/show-issues/?factory_id=${id}`),
  markIssue: (id) => http.delete(`factory/supplier/issue/${id}/`),
  replySolution: (issue, description, price, images) => {
    let fd = new FormData()
    fd.append('issue', issue)
    fd.append('description', description)
    fd.append('price', price)

    var ins = images.length
    for (var x = 0; x < ins; x++) {
      fd.append('uploaded_images', images[x])
    }

    return http.post('factory/supplier/reply-solution/', fd)
  },
  visitSchedule: () => http.get('factory/supplier/visit-schedule/'),
  addVisitSchedule: (factory_id, date, from, to) =>
    http.post('factory/supplier/visit-schedule/', {
      factory: factory_id,
      schedule_date: [
        {
          date: date,
          from: from,
          to: to,
        },
      ],
    }),
  deleteWatcher: (id) => http.delete(`factory/watcher/${id}/`),
  resourceList: (page = 1, search = null) =>
    http.get(`factory/compute-resource/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  readResource: (id) => http.get(`factory/compute-resource/${id}/`),
  addResource: (name, register_id) =>
    http.post('factory/compute-resource/', {
      name: name,
      register_id: register_id,
    }),
  editResource: (id, name, register_id) =>
    http.patch(`factory/compute-resource/${id}/`, {
      name: name,
      register_id: register_id,
    }),
  deleteResource: (id) => http.delete(`factory/compute-resource/${id}/`),
  jobs: () => http.get('factory/job/'),
  addJob: (station_id, computation_id, rerun, notif) =>
    http.post('factory/job/', {
      input_source: null,
      output_source: null,
      station: station_id,
      computation_reg: computation_id,
      rerun_on: rerun,
      is_notificable: notif,
    }),
  editJob: (id, rerun, notif) =>
    http.patch(`factory/job/${id}/`, {
      rerun_on: rerun,
      is_notificable: notif,
    }),
  deleteJob: (id) => http.delete(`factory/job/${id}/`),
  tables: () => http.get('factory/table/'),
  companies: (page = 1) => http.get(`factory/factories/?page=${page}`),
  readCompany: (id) => http.get(`factory/factories/${id}/`),
  factoryInfo: () => http.get('factory/factory-info/'),
  uploadFactoryImage: (image, name) => {
    let fd = new FormData()
    fd.append('factory_logo', image)
    fd.append('name', name)
    return http.put('factory/factory-info/', fd)
  },
  removeComanyImage: (name) => http.put('factory/factory-info/', { factory_logo: null, name }),
  updateFactory: (factory_site, location, name, points) => {
    return http.put('factory/factory-info/', {
      factory_site: factory_site,
      location: location,
      name: name,
      array_point: points,
    })
  },
  uploadFactoryMapImage: (image, name) => {
    let fd = new FormData()
    fd.append('image', image)
    fd.append('name', name)
    return http.put('factory/factory-info/', fd)
  },
  removeFactoryImage: (name) => {
    return http.put('factory/factory-info/', {
      image: null,
      array_point: null,
      name,
    })
  },
  updateFactoryRepeat: (repeat) =>
    http.put('factory/factory-info/', {
      is_schedule_repeat: repeat,
    }),
  editFactory: () => http.put('factory/factory-info/'),
  createLocation: (name, location) =>
    http.post('factory/location/', {
      name: name,
      lat: location.lat,
      lon: location.lng,
      address: location.address,
    }),
  readLocation: (id) => http.get(`factory/location/${id}/`),
  editLocation: (id, location) =>
    http.patch(`factory/location/${id}/`, {
      lat: location.lat,
      lon: location.lng,
      address: location.address,
    }),
  operations: (id = null, page = 1, station = null, active = true, product = null, search = null) =>
    http.get(
      `factory/operation/?page=${page}${id ? `&line=${id}` : ''}${station ? `&station=${station}` : ''}${product ? `&product=${product}` : ''}&is_active=${active}${search !== null ? `&search=${search}` : ''}`
    ),
  getOperation: (id) => http.get(`factory/operation/${id}/`),
  addOperation: (name, shift, product, grades, desired, desire_duration, line, operator, station) => {
    let duration = desire_duration === 'shift' ? 0 : desire_duration === 'hours' ? 3600 : parseInt(desire_duration)
    return http.post('factory/operation/', {
      operation_name: name,
      shift: shift,
      product: product,
      grade: grades,
      desire_quantity: desired,
      desire_duration: duration,
      line: line,
      station: station,
      is_active: true,
      user_operation: operator,
    })
  },
  editOperation: (id, blob) => {
    let fd = new FormData()
    fd.append('image', new File([blob], `${id}.jpg`))
    fd.append('is_active', true)
    return http.patch(`factory/operation/${id}/`, fd)
  },
  editOperationGraph: (id, station, graph) =>
    http.patch(`factory/operation/${id}/`, {
      station: station,
      graph: graph,
      is_active: true,
    }),
  editOperationOperators: (id, operators) =>
    http.patch(`factory/operation/${id}/`, {
      user_operation: operators,
    }),
  editOperationData: (id, name, shift, product, grades, desire_quantity, desire_duration, operator) => {
    let duration = desire_duration === 'shift' ? 0 : desire_duration === 'hours' ? 3600 : parseInt(desire_duration)
    return http.patch(`factory/operation/${id}/`, {
      operation_name: name,
      shift: shift,
      product: product,
      grade: grades,
      desire_quantity: desire_quantity,
      desire_duration: duration,
      is_active: true,
      user_operation: operator,
    })
  },
  editOperationMirror: (id, is_mirror) =>
    http.put(`factory/operation/${id}/`, {
      is_mirror: is_mirror,
    }),
  editOperationMultiplication: (id, multipliections, salary_ratio, processing_time, descriptions) =>
    http.put(`factory/operation/${id}/`, {
      multipliections: multipliections,
      salary_ratio: salary_ratio,
      processing_time: processing_time,
      descriptions: descriptions,
    }),
  operationData: (operation_id, station_id, start, stop) =>
    http.get(
      `elastic-search/operation-all-data/?${
        operation_id ? 'operation_id=' + operation_id + '&' : ''
      }${station_id ? 'station_id=' + station_id + '&' : ''}${
        start ? 'start_date=' + start + '&' : ''
      }${stop ? 'stop_date=' + stop : ''}`
    ),
  // addOperationStation: (id, station_id) => http.patch(`factory/operation/${id}/`, {
  //   station:
  // }),
  stationHistory: (factory_id, station_id, start, stop) =>
    http.get(
      `elastic-search/supplier/station/?factory_id=${factory_id}&station_id=${station_id}&start_date=${start}&stop_date=${stop}`
    ),
  getSummaryAverage: (start_date, stop_date) =>
    http.get(`elastic-search/report-shift/avarage?start_date=${start_date}&stop_date=${stop_date}`),
  deleteOperation: (id) =>
    http.patch(`factory/operation/${id}/`, {
      is_active: false,
    }),
  restoreOperation: (id) =>
    http.patch(`factory/operation/${id}/`, {
      is_active: true,
    }),
  productList: (page = 1, search = null) =>
    http.get(`factory/product/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  readProduct: (id) => http.get(`factory/product/${id}/`),
  createProduct: (name, number, chars, type, description, grades, image) => {
    var fd = new FormData()
    fd.append('product_name', name)
    fd.append('product_number', number)
    chars.forEach((element) => {
      fd.append('characteristics', element)
    })
    // fd.append('production_type', type)
    fd.append('document', description)
    grades.forEach((element) => {
      fd.append('grade', element)
    })
    if (image) {
      fd.append('image', image)
    }
    return http.post('factory/product/', fd, { headers: { "Content-Type": "multipart/form-data" } })
  },
  editProduct: (id, name, number, chars, type, description, grades, image) => {
    var fd = new FormData()
    fd.append('product_name', name)
    fd.append('product_number', number)
    chars.forEach((char) => {
      console.log(char)
      fd.append('characteristics', char)
    })
    // fd.append('production_type', type)
    fd.append('document', description)
    grades.forEach((element) => {
      fd.append('grade', element)
    })
    if (image) fd.append('image', image)
    return http.put(`factory/product/${id}/`, fd, { headers: { "Content-Type": "multipart/form-data" } })
  },
  patchProduct: (id, body) => http.patch(`factory/product/${id}/`, body),
  deleteProduct: (id) => http.delete(`factory/product/${id}/`),
  userInfo: (user_id) => http.get(`user/users-info/${user_id}/`),
  uploadProfileImage: (user_id, image) => {
    let fd = new FormData()
    fd.append('profile_image', image)
    return http.put(`user/users-info/${user_id}/`, fd)
  },
  removeProfileImage: (user_id) =>
    http.put(`user/users-info/${user_id}/`, {
      profile_image: null,
    }),
  updateProfile: (user_id, first_name, last_name, country_code, phone) => {
    return http.put(`user/users-info/${user_id}/`, {
      first_name: first_name,
      last_name: last_name,
      phone: phone,
      country_code: country_code,
    })
  },
  removeImage: (user_id) => http.put(`user/users-info/${user_id}/`, { profile_image: null }),
  changePassword: (user_id, new_password, confirm_password) =>
    http.put(`user/users-info/${user_id}/`, {
      new_password: new_password,
      confirm_password: confirm_password,
    }),
  operationStatistics: (page = 1) => http.get(`factory/operation-statistics/?page=${page}`),
  readOperation: (id) => http.get(`factory/operation/${id}/`),
  categories: (station_id, page = 1) =>
    http.get(`factory/category/?page=${page}${station_id ? `&station=${station_id}` : ''}`),
  readCategory: (id) => http.get(`factory/category/${id}/`),
  addCategory: (name, color, desc, station) =>
    http.post('factory/category/', {
      category_name: name,
      color: color,
      description: desc,
      station: station,
    }),
  editCategory: (id, name, color, desc) =>
    http.patch(`factory/category/${id}/`, {
      category_name: name,
      color: color,
      description: desc,
    }),
  editLabel: (id, station_id) =>
    http.patch(`factory/category/${id}/`, {
      station: station_id,
    }),
  deleteLabel: (id) => http.delete(`factory/category/${id}/`),
  annotationList: (operation_id, station_id) =>
    http.get(`factory/annotation/?${operation_id ? 'operation=' + operation_id + '&' : ''}station=${station_id}`),
  createAnnotation: (operation_id, station_id, start, end, label, start_id, end_id, description) =>
    http.post('factory/annotation/', {
      start: start,
      end: end,
      timeserieslabels: [label],
      operation: operation_id,
      station: station_id,
      start_id: start_id,
      end_id: end_id,
      description: description,
    }),
  updateAnnotation: (id, start, end, label, start_id, end_id, description) =>
    http.patch(`factory/annotation/${id}/`, {
      start: start,
      end: end,
      timeserieslabels: [label],
      start_id: start_id,
      end_id: end_id,
      description: description,
    }),
  deleteAnnotation: (id) => http.delete(`factory/annotation/${id}/`),
  export_csv: (id, fields, start, stop) =>
    http.get(
      `elastic-search/export/?list_filter=${fields}${
        id ? `&operation_id=${id}` : ''
      }&start_date=${start}&stop_date=${stop}`
    ),
  notification: () => http.get(`notifications/all/`),
  read_notification: (id) => {
    if (id) {
      return http.get(`notifications/mark-as-read/${id}`)
    }
    return http.get('notifications/mark-all-as-read/')
  },
  clear_notification: (id) => http.delete(`notifications/delete/${id}/`),
  plans: () => http.get('factory/plan/'),
  amount_send: (amount) =>
    http.post('payment/idpay/send/', {
      amount: amount,
    }),
  upgrade_plan: (id) => http.post('payment/pay-plan/', { plan: id }),
  charge_wallet: (amount) => http.post('payment/idpay/pay-amount/', { amount: amount }),
  payments: (page = 1) => http.get(`payment/user-payments/?page=${page}`),
  email_verify: (email) =>
    http.post('user/email_verified/', {
      email: email,
    }),
  check_email: (email, code) =>
    http.post('user/check_email_verified/', {
      email: email,
      code: code,
    }),
  load_integration: () => http.get('factory/integration/'),
  add_integration: (name, message_type, user_id) =>
    http.post('factory/integration/', {
      name: name,
      user_id: user_id,
      message_type: message_type,
      is_active: true,
    }),
  active_integration: (id, active) =>
    http.patch(`factory/integration/${id}/`, {
      is_active: active,
    }),
  update_integration: (id, name, message_type, user_id) =>
    http.patch(`factory/integration/${id}/`, {
      name: name,
      user_id: user_id,
      message_type: message_type,
    }),
  remove_integration: (id) => http.delete(`factory/integration/${id}/`),
  generate_link: (station, start, stop, product, chart, is_buyer, buyer, operation) =>
    http.post('factory/admin-buyer/generate-link/', {
      station: station,
      start_time: start,
      stop_time: stop,
      product: product,
      incloud_chart: chart,
      is_send_to_buer: is_buyer,
      buyer: buyer,
      operation: operation,
    }),
  factoryBuyers: (page = 1, search = null) =>
    http.get(`factory/buyer/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  /**
   * @typedef {Object} GenerateLink
   * @property {number} station
   * @property {string} start_time
   * @property {string} stop_time
   * @property {number} product
   * @property {boolean} incloud_chart
   * @property {boolean} is_send_to_buyer
   * @property {number} buyer
   * @property {number} operation
   * @property {number} [grade]
   * @property {number} [buyer]
   * @property {number} [lot_info]
   * @property {string} [sales_order]
   * @property {string} [description]
   * @property {Blob[]} [png_files]
   */
  /**
   * @param {number} id
   * @param {GenerateLink} update
   */
  updateGenerateLink: (id, update) => http.put(`factory/admin-buyer/generate-link/${id}`, update, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),
  /**
   * @param {GenerateLink} generateLink
   */
  generateLink: (generateLink) => http.post('factory/admin-buyer/generate-link/', generateLink, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),
  deleteGenerateLink: (id) => http.delete(`factory/admin-buyer/generate-link/${id}`),
  deleteFactoryBuyer: (id) => http.delete(`factory/buyer/${id}`),
  buyers: (page = 1) => http.get(`user/users-buyers/?page=${page}`),
  readBuyer: (id) => http.get(`user/users-buyers/${id}/`),
  buyerRegister: (email, password, country_code, phone, factory_name) =>
    http.post('user/buyer-register/', {
      email,
      password,
      country_code,
      phone,
      factory_name,
    }),
  buyerProduct: (page = 1, count) => http.get(`user/buyer/?page=${page}${count ? `&count=${count}` : ''}`),
  orderProduct: (uuid) => http.get(`factory/buyer-product-info/?uuid=${uuid}`),
  grades: (page = 1) => http.get(`factory/grade/?page=${page}`),
  readGrade: (id) => http.get(`factory/grade/${id}/`),
  newGrade: (name, lower_limit) =>
    http.post('factory/grade/', {
      name: name,
      lower_limit: lower_limit,
    }),
  removeGrade: (id) => http.delete(`factory/grade/${id}/`),
  sampleField: () => http.get('elastic-search/get-sampel-field/'),
  authCode: () => http.get('user/get-last-email-verify/'),
  updateStationSettings: (id, settings) =>
    http.patch(`factory/station/${id}/`, {
      extra_settings: settings,
    }),
  reportDowntime: (start, end, station, label) =>
    http.post('factory/annotation/', {
      start: start,
      end: end,
      station: station,
      timeserieslabels: [label],
    }),
  rawMaterials: (page = 1) => http.get(`factory/raw-material/?page=${page}`),
  characteristics: (page = 1, search = null) =>
    http.get(`factory/characteristics/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  addCharacteristic: (name, options) => http.post('factory/characteristics/', { name, options }),
  updateCharacteristic: (id, name, options) => http.put(`factory/characteristics/${id}/`, { name, options }),
  readCharacteristic: (id) => http.get(`factory/characteristics/${id}/`),
  deleteCharacteristic: (id) => http.delete(`factory/characteristics/${id}/`),
  batchTemplates: (count) => http.get(`factory/batch-template/?count=${count}`),
  getBatchTemplate: (id) => http.get(`factory/batch-template/${id}/`),
  createBatchTemplate: (product, characteristics, name) => http.post('factory/batch-template/', { ...(() => product ? { product } : {}), characteristics, name }),
  updateBatchTemplate: (id, product, characteristics, name) =>
    http.put(`factory/batch-template/${id}/`, { ...(() => product ? { product } : {}), characteristics, name }),
  salesOrders: (page = 1, isActive = true, search = null, product = null, buyer = null, hasNoShipment = false) =>
    http.get(
      `factory/sales-order/?page=${page}&is_active=${isActive}${search !== null ? `&search=${search}` : ''}${product !== null ? `&product=${product}` : ''}${buyer !== null ? `&buyer=${buyer}` : ''}${hasNoShipment ? `&has_no_shipment=true` : ''}`
    ),
  getSalesOrder: (id) => http.get(`factory/sales-order/${id}/`),
  createSalesOrder: (buyer, quantity, start_date, delivery_date, description, product, file, factory, shipment = null) => {
    const form = new FormData()
    form.append('buyer', buyer)
    form.append('quantity', quantity)
    form.append('start_date', start_date)
    form.append('delivery_date', delivery_date)
    form.append('description', description)
    form.append('product', product)
    form.append('is_active', true)
    if(shipment) form.append('shipment', shipment)
    if (factory) {
      form.append('factory', factory)
    }
    if (file) {
      form.append('file', file)
    }
    return http.post('factory/sales-order/', form)
  },
  updateSalesOrder: (id, buyer, quantity, start_date, delivery_date, description, product, file, factory, shipment = null) => {
    const form = new FormData()
    form.append('buyer', buyer)
    form.append('quantity', quantity)
    form.append('factory', factory)
    form.append('start_date', start_date)
    form.append('delivery_date', delivery_date)
    form.append('description', description)
    form.append('product', product)
    form.append('is_active', true)
    if(shipment) form.append('shipment', shipment)
    if (file) {
      form.append('file', file)
    }
    return http.put(`factory/sales-order/${id}/`, form)
  },
  restoreSalesOrder: (id) => http.patch(`factory/sales-order/${id}/`, { is_active: true }),
  deleteSalesOrder: (id) => http.delete(`factory/sales-order/${id}/`),
  batches: () => http.get('elastic-search/batch/'),
  getBatch: (sales_order) => http.get(`elastic-search/batch/?sales_order=${sales_order}`),
  getBatchByUuid: (uuid) => http.get(`elastic-search/batch/?batch_uuid=${uuid}`),
  getBatchByAssignId: (assignId) => http.get(`elastic-search/batch/?assigned_id=${assignId}`),
  createBatch: (sales_order, product, batches) =>
    http.post('elastic-search/batch/', {
      sales_order,
      product,
      batches,
    }),
  updateBatch: (elasticId, batches) => http.put(`elastic-search/batch-detail/${elasticId}`, { batch: { batches } }),
  deleteBatch: (productId) => http.delete(`elastic-search/delete-batch/?product_id=${productId}`),
  deleteBatchDetail: (elasticId) => http.delete(`elastic-search/batch-detail/${elasticId}`),
  batchReports: () => http.get('elastic-search/batch-reports'),
  getBatchReportsByTime: (from, to, controller) =>
    http.get(`elastic-search/batch-reports/?from_timestamp=${from}&to_timestamp=${to}`, { signal: controller.signal }),
  getBatchReportsByUuid: (uuid) => http.get(`elastic-search/batch-reports/?batch_uuid=${uuid}`),
  getBatchReportsByAssignId: (assignId) => http.get(`elastic-search/batch-reports/?assigned_id=${assignId}`),
  getBatchReportsWithFilter: (batch_uuid, operator, station, type) =>
    http.get(
      `elastic-search/batch-reports/?batch_uuid=${batch_uuid}&operator=${operator}&station=${station}&type=${type}`
    ),
  getBatchReportClculations: (order_ids, station_id = null, ignoreError = false) => http.get(`elastic-search/batch-report-calculations/?orders=[${order_ids.join(',')}]${station_id ? `&station_id=${station_id}` : ''}`, { ignoreError }),
  sendBatchReports: (
    batch_uuid = null,
    order_id = null,
    type,
    station,
    operator = null,
    defect_qty = null,
    added_quantity = null,
    assigned_id = null,
    defect_image = null,
    action_type,
    extra_info = null
  ) => {
    const data = {
      type,
      station,
      action_type,
    }
    if (batch_uuid !== null) data.batch_uuid = batch_uuid
    if (order_id !== null) data.order_id = order_id
    if (defect_qty !== null) data.defect_qty = defect_qty
    if (added_quantity !== null) data.added_quantity = added_quantity
    if (assigned_id !== null) data.assigned_id = assigned_id
    if (extra_info !== null) data.extra_info = extra_info
    if (operator !== null) data.operator = operator
    if (defect_image !== null) data.defect_image = defect_image
    return http.post('/elastic-search/send-batch-report/', data)
  },
  updateBatchReports: (
    elasticId,
    batch_uuid,
    order_id,
    type,
    station,
    operator,
    defect_qty,
    added_quantity,
    assigned_id,
    defect_image,
    action_type
  ) => {
    const data = {
      batch_uuid,
      order_id,
      type,
      station,
      operator,
      defect_qty,
      added_quantity,
      defect_image,
      action_type,
    }
    if (assigned_id !== null) data.assigned_id = assigned_id
    return http.put(`/elastic-search/detail-batch-report/${elasticId}`, { data })
  },
  shipments: (page = 1, search = null) => http.get(`factory/shipment-orders/?page=${page}${search !== null ? `&search=${search}` : ''}`),
  shipment: (number) => http.get(`factory/shipment/${number}/`),
  createShipment: (shipment_number, type, destination, orders) => http.post('factory/shipment/', {shipment_number, type, destination, orders}),
  updateShipment: (number, shipment_number, type, destination, orders) => {
    const payload = {type, destination, orders}
    if(shipment_number) {
      payload.shipment_number = shipment_number
    }
    return http.put(`factory/shipment/${number}/`, payload)
  },
  patchShipment: (shipmentNumber, data) => http.patch(`factory/shipment/${shipmentNumber}/`, data),
  deleteShipment: (number) => http.delete(`factory/shipment/${number}/`),
  downloadBatchReports: (from, to) => http.get(`elastic-search/export-batch-reports/${from ? '?from_timestamp=' + from : ''}${to ? '&to_timestamp=' + to : ''}`),
  downloadShipmentReports: (from, to) => http.get(`elastic-search/export-shipment-report/${from ? '?from_timestamp=' + from : ''}${to ? '&to_timestamp=' + to : ''}`, { responseType: 'arraybuffer' }),
  allLines: () => http.get('factory/all-lines/'),
  allOperations: () => http.get('factory/all-operations/'),
  allProducts: () => http.get('factory/all-products/'),
  allStations: () => http.get('factory/all-stations/'),
  importShipmentOrders: (file) => {
    const fd = new FormData()
    fd.append('file', file)
    return http.post('factory/import-shipment-orders/', fd, { headers: { "Content-Type": "multipart/form-data" } })
  },
  getShipmentNotes: (shipment_number) => http.get(`elastic-search/batch-reports/?extra_info.shipment_number=${shipment_number}&is_exist.extra_info.note=true`),
  getShipmentReports: (from, to, ignoreError = false, controller) =>
    http.get(`elastic-search/export-shipment-report/?from_timestamp=${from}&to_timestamp=${to}&download=false`, { signal: controller.signal, ignoreError }),
}
